import { cn } from "../../utils/cn";
import * as React from "react";
import { useMotionTemplate, useMotionValue, motion } from "framer-motion";
import { Link } from "react-router-dom";

export const BentoGrid = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "grid md:auto-rows-[18rem] grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto ",
        className
      )}
    >
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  title,
  description,
  header,
  icon,
  img,
  type,
  route = "/",
}: {
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  header?: React.ReactNode;
  icon?: React.ReactNode;
  img?: React.ReactNode;
  type?: string;
  route?:string;
}) => {
  const Content = () => {
    return (
    <>
      <div className="group-hover/bento:translate-x-2 transition duration-200">
        {icon}
        <div className="font-sans font-bold text-neutral-600 dark:text-neutral-200 mb-2">
          {title}
        </div>
        <div className="font-sans font-normal text-neutral-600 text-xs dark:text-neutral-300">
            {description}
        </div>
      </div>
    </>
    )
  }

  return (
    <div
      className={cn(
        "gridItemsWoShadow items h-full row-span-1 rounded-xl group/bento hover:shadow-xl transition duration-200 shadow-input dark:shadow-none p-4 dark:bg-black dark:border-white/[0.2] bg-white border border-transparent justify-between flex flex-col space-y-4",
        className
      )}
    >
      <Link
        to={route}
      >
        <div className=" flex-1 w-full justify-center overflow-hidden">
          {img}
          {header}
        </div>
        {type!="list" && <Content/>}
      </Link>
    </div>
  );
};
